import React, { useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import _ from 'lodash';
import ActionButton from './ActionButton';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const HowItWorksSteps = ({ howItWorksSteps, setHowItWorksSteps, isEditor = true }:
  { howItWorksSteps: any; setHowItWorksSteps?: any; isEditor?: boolean }) => {
  const handleDataChange = (index, value) => {
    howItWorksSteps[index] = value;
    setHowItWorksSteps(howItWorksSteps);
  };

  const handleAddItem = () => {
    const itemsCopy = _.clone(howItWorksSteps);
    itemsCopy.push({ title: '', description: '' });
    setHowItWorksSteps(itemsCopy);
  };

  const handleRemoveItem = (index) => {
    const newItems = _.clone(howItWorksSteps);
    newItems.splice(index, 1);
    setHowItWorksSteps(newItems);
  };

  function getHowItWorksMDEditorInputs() {
    return howItWorksSteps?.length > 0 ? howItWorksSteps.map((item, index) => (
      <div className="card mb-3" key={index}>
        <div className="card-header">Step {(1 + index)}</div>
        <div className="card-body">
          <label className='text-muted'>Title</label>
          <MDEditor
            placeholder='Title'
            height={105}
            className='mb-2'
            value={item.title}
            onChange={(value) => handleDataChange(index, { ...item, title: value })}
          />
          <label className='text-muted'>Description</label>
          <MDEditor
            height={150}
            placeholder='Description'
            value={item.description}
            onChange={(value) => handleDataChange(index, { ...item, description: value })}
          />
          <button
            className="btn btn-danger mt-2"
            onClick={() => handleRemoveItem(index)}
          >
            Remove
          </button>
        </div>
      </div>
    )) : null;
  }

  function getHowItWorksEditor() {
    if (isEditor) {
      return (
        <>
          {getHowItWorksMDEditorInputs()}
          <ActionButton
            active
            isLoading={false}
            onClick={handleAddItem}
            text={'+ Add Step'}
          />
        </>
      );
    } else return getHowItWorksPreviewer();
  }

  function getHowItWorksPreviewer() {
    return howItWorksSteps.map((item, index) => (
      <div className="card mb-3" key={index}>
        <div className="card-header">Step {index + 1}</div>
        <div className="card-body">
          <label className='text-muted'>Title</label>
          <MDEditor.Markdown
            className='mb-2'
            source={item.title}
          />
          <label className='text-muted'>Description</label>
          <MDEditor.Markdown
            source={item.description}
          />
        </div>
      </div>
    ));
  }
  return (
    <div className="container mt-5">
      {getHowItWorksEditor()}
    </div>
  );
};

export default HowItWorksSteps;
